import HomeCard from "../HomeCard";
import "./HomeCard0.css";

const HomeCard0 = () => {
    return <HomeCard className={"home-card-0"} itemType={"zepeto"} itemKey={2} itemName="KB 국민카드 리브메이트 월드" itemDesc="메타버스 자산관리 체험 서비스, 금융 마케팅의 한계를 넘다" />
};

export default HomeCard0;
